import { screens } from '@change/ds-tokens/screens';

import type { EventTrackingDecorator } from '@change-corgi/core/eventTracker';

type BreakpointName = 'sm' | 'md' | 'lg' | 'xl';

class BreakpointSizeDecorator implements EventTrackingDecorator {
	private readonly smQuery: MediaQueryList | null;
	private readonly mdQuery: MediaQueryList | null;
	private readonly lgQuery: MediaQueryList | null;
	private readonly xlQuery: MediaQueryList | null;

	constructor() {
		if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') {
			// SSR safety
			this.smQuery = null;
			this.mdQuery = null;
			this.lgQuery = null;
			this.xlQuery = null;
		} else {
			this.smQuery = window.matchMedia(`(min-width: ${screens.sm}px)`);
			this.mdQuery = window.matchMedia(`(min-width: ${screens.md}px)`);
			this.lgQuery = window.matchMedia(`(min-width: ${screens.lg}px)`);
			this.xlQuery = window.matchMedia(`(min-width: ${screens.xl}px)`);
		}
	}

	async getEventTrackingData(): Promise<Readonly<Record<string, unknown>>> {
		if (!this.smQuery || !this.mdQuery || !this.lgQuery || !this.xlQuery) return Promise.resolve({});
		return Promise.resolve({
			breakpoint_size: this.currentBreakpoint(),
		});
	}

	private currentBreakpoint(): BreakpointName | null {
		if (!this.smQuery || !this.mdQuery || !this.lgQuery || !this.xlQuery) return null;

		if (this.xlQuery.matches) return 'xl';
		if (this.lgQuery.matches) return 'lg';
		if (this.mdQuery.matches) return 'md';
		if (this.smQuery.matches) return 'sm';
		return 'sm';
	}
}

export function createBreakpointSizeDecorator(): BreakpointSizeDecorator {
	return new BreakpointSizeDecorator();
}
